var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-button",
    {
      staticClass: "custom-btn",
      style: _vm.customStyle,
      attrs: { loading: _vm.loading, type: "primary" },
      nativeOn: {
        click: function($event) {
          $event.preventDefault()
          return _vm.handleClick($event)
        }
      }
    },
    [_vm._v(" " + _vm._s(_vm.text) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }